import config from "./app";

const WidgetConfig = {
  tiledGallery: {
    get url() {
      return `${config.libraryURL}/widgets/tiled-gallery/1.0.6/widget.html`;
    },
  },

  slidingGallery: {
    get url() {
      return `${config.libraryURL}/widgets/sliding-gallery/2.0.4/widget.html`;
    },
  },

  protorenderer: {
    /** The release STAGE_CSS and the test fixtures are written against. */
    defaultVersion: "1.6.2",

    /** The widget folder of `engineVersion` from the app config, else of `defaultVersion`. */
    get widgetsURL() {
      const version = config.engineVersion || this.defaultVersion;
      // A protocol-relative host gets https:, so http pages skip a redirect on every widget file.
      const host = config.libraryURL.startsWith("//")
        ? `https:${config.libraryURL}`
        : config.libraryURL;
      return `${host}/protorenderer/${version}/widgets/`;
    },
  },
};

export default WidgetConfig;
